export default function ({ date, monetaryUnit, model, rlv, ...ps}) {
        return {
          date,
          monetaryUnit,
          //model, // commented out because clutters view
          nscore: rlv.nscore,
          score: rlv.score,
          targetScore: rlv.target,
          variables: Object.entries(ps).map(([key, value]) => legacyVariable[key] && legacyVariable[key](value))
        }
      }
      const legacyVariable = {
        prc: ({ score, target, nscore, ...components }) => ({
          id: 'price',
          apiId: 'prc',
          name: 'Price',
          score,
          nscore,
          target,
          components: mapComponents(components)
        }),
        prd: ({ score, target, nscore, ...components }) => ({
          id: 'product',
          apiId: 'prd',
          name: 'Product',
          score,
          nscore,
          target,
          components: mapComponents(components)
        }),
        plc: ({ score, target, nscore, ...components }) => ({
          id: 'place',
          apiId: 'plc',
          name: 'Place',
          score,
          nscore,
          target,
          components: mapComponents(components)
        }),
        prm: ({ score, target, nscore, ...components }) => ({
          id: 'promotion',
          apiId: 'prm',
          name: 'Promotion',
          score,
          nscore,
          target,
          components: mapComponents(components)
        }),
        prf: ({ score, target, nscore, ...components }) => ({
          id: 'preference',
          apiId: 'prf',
          name: 'Preference',
          nscore,
          score,
          target,
          components: mapComponents(components)
        }),
        prp: ({ score, target, nscore, ...components }) => ({
          id: 'proposal',
          apiId: 'prp',
          name: 'Proposal',
          score,
          nscore,
          target,
          components: mapComponents(components)
        }),
        ppl: ({ score, target, nscore, ...components }) => ({
          id: 'people',
          apiId: 'ppl',
          name: 'People',
          score,
          nscore,
          target,
          components: mapComponents(components)
        })
      }
      const mapComponents = (components) => Object.assign({}, ...Object.entries(components).map(([key, value]) => legacyComponent[key] && legacyComponent[key](value)).filter(Boolean))
      const legacyComponent = {
        words: (words) => ({
          "sentimentWordCloud": {
            "type": 'word cloud',
            "title": 'Sentiment (Wordcloud)',
            "words": Object.entries(words).map(([word, freq]) => ({ word, freq })).sort((a,b) => b.freq - a.freq).slice(0,5)
          }
        }),
        perception: (values) => ({
          "perception": {
            "type": "perception",
            "title": "Perception",
            "perception": values
          }
        }),
        ad_awareness: ({yes,no}) => ({
          "adAwareness": {
            "type": "chart",
            "title": "Ad awareness",
            "description": "Have the respondants seen any commercial from the advertiser?",
            "unit": "percentage",
            "values": [
              {
                "name": "Yes",
                "value": yes
              },
              {
                "name": "No",
                "value": no
              }
            ]
          }
        }),
        wom_exposure: ({yes,no}) => ({
          "womExposure": {
            "type": "chart",
            "title": "WOM Exposure",
            "description": "Have you talked about the brand to friends or family?",
            "unit": "percentage",
            "values": [
              {
                "name": "Yes",
                "value": yes
              },
              {
                "name": "No",
                "value": no
              }
            ]
          }
        })
      }



// WEBPACK FOOTER //
// ./src/actions/mapDataToComponents.js